"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3524],{

/***/ 83524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PackagesCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ScrollableDealModule/index.tsx + 1 modules
var ScrollableDealModule = __webpack_require__(89162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/set-deal-content.ts


var PACKAGE_DISPLAY_MINIMUM = 3;
function setDealContent(deals) {
    if (!Array.isArray(deals) || deals.length < PACKAGE_DISPLAY_MINIMUM) {
        throw new Error("Not enough packages to display deals");
    }
    return deals.map(function(deal) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, deal), {
            id: "PACKAGE_DEAL_".concat(deal.cityName.slice(-2)),
            image: deal.cityImageUrl,
            imageHeight: "284px",
            gaCategory: "PACKAGES_LANDING",
            gaAction: "Cached Deal",
            strikePrice: deal.priceAmount < deal.retailPriceAmount ? deal.retailPriceAmount : 0,
            gaLabel: deal.cityName,
            navArray: [
                {
                    href: deal.searchLink,
                    target: "_blank"
                }
            ]
        });
    });
}
/* harmony default export */ var set_deal_content = (setDealContent);

;// CONCATENATED MODULE: ./src/utils/get-bundle-deals.ts






var PKG_DEALS_QUERY = "\n  query PKG($input: BundleDealsInput) {\n    getBundleDeals(input: $input) {\n      bundles {\n        cityName\n        cityImageUrl\n        priceAmount\n        retailPriceAmount\n        searchLink\n        productName\n        description\n      }\n    }\n  }\n";
var fetchDataFromBundleDeals = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var latitude, longitude, ref, url, timeout, result, ref1, errors, data, bundles;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    latitude = param.latitude, longitude = param.longitude;
                    ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                    return [
                        4,
                        esm_default()({
                            url: url,
                            timeout: timeout,
                            method: "POST",
                            data: {
                                query: PKG_DEALS_QUERY,
                                variables: {
                                    input: {
                                        latitude: latitude,
                                        longitude: longitude
                                    }
                                }
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    ref1 = (result === null || result === void 0 ? void 0 : result.data) || {}, errors = ref1.errors, data = ref1.data;
                    if (errors) {
                        throw new Error("Error in getBundleDeals query response: ".concat(JSON.stringify(errors)));
                    }
                    bundles = ((data === null || data === void 0 ? void 0 : data.getBundleDeals) || {}).bundles;
                    return [
                        2,
                        bundles
                    ];
            }
        });
    });
    return function fetchDataFromBundleDeals(_) {
        return _ref.apply(this, arguments);
    };
}();
var getBundleDeals = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var latitude, longitude, bundles, error, ref, ref1, errorMessage, errors;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    latitude = param.latitude, longitude = param.longitude;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetchDataFromBundleDeals({
                            latitude: latitude,
                            longitude: longitude
                        })
                    ];
                case 2:
                    bundles = _state.sent();
                    return [
                        2,
                        set_deal_content(bundles)
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = error.message;
                    errors = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.errors;
                    if (errors) {
                        errorMessage += " - Errors: ".concat(JSON.stringify(errors));
                    }
                    errorMessage = "Failed to call Bundle Deals api!\n" + "lat: ".concat(Number(latitude), "\n") + "lon: ".concat(Number(longitude), "\n") + "message: ".concat(errorMessage);
                    analytics/* default.logError */.Z.logError({
                        message: errorMessage
                    });
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBundleDeals(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var get_bundle_deals = (getBundleDeals);

;// CONCATENATED MODULE: ./src/utils/get-price-cache.ts





var PACKAGE_PRICE_CACHE_ENDPOINT = "/pws/v0/psapi/search/pricecache";
var fecthDataFromPriceCache = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var latitude, longitude, queryString, url, result, ref, packages, message;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    latitude = param.latitude, longitude = param.longitude;
                    queryString = "?latitude=".concat(latitude, "&longitude=").concat(longitude);
                    url = "".concat(PACKAGE_PRICE_CACHE_ENDPOINT).concat(queryString);
                    return [
                        4,
                        esm_default()({
                            url: url,
                            method: "GET",
                            headers: {
                                "Cache-Control": "private, max-age=900"
                            }
                        })
                    ];
                case 1:
                    result = _state.sent();
                    ref = (result === null || result === void 0 ? void 0 : result.data) || {}, packages = ref.packages, message = ref.message;
                    if (message) {
                        throw new Error("Error in getPriceCache query response: ".concat(JSON.stringify(message)));
                    }
                    return [
                        2,
                        packages
                    ];
            }
        });
    });
    return function fecthDataFromPriceCache(_) {
        return _ref.apply(this, arguments);
    };
}();
var getPriceCache = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var latitude, longitude, bundles, error, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    latitude = param.latitude, longitude = param.longitude;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fecthDataFromPriceCache({
                            latitude: latitude,
                            longitude: longitude
                        })
                    ];
                case 2:
                    bundles = _state.sent();
                    return [
                        2,
                        set_deal_content(bundles)
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = error.message;
                    errorMessage = "Failed to call Price Cache api!\n" + "lat: ".concat(Number(latitude), "\n") + "lon: ".concat(Number(longitude), "\n") + "message: ".concat(errorMessage);
                    analytics/* default.logError */.Z.logError({
                        message: errorMessage
                    });
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPriceCache(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var get_price_cache = (getPriceCache);

// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
;// CONCATENATED MODULE: ./src/hooks/useFetchPackages.ts






var useFetchPackages = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var ref = (0,react.useState)([]), deals = ref[0], setDeals = ref[1];
    var ref1 = (0,react.useState)(true), didFetchSucceed = ref1[0], setFetchSucceeded = ref1[1];
    var shouldUseGraphQl = (0,useSeti/* default */.Z)("PKG_LANDING_DEALS_FETCH_METHOD", true) === "VARIANT";
    (0,react.useEffect)(function() {
        var fetchPackageDeals = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var bundleDeals, _tmp;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!latitude || !longitude) {
                                return [
                                    2,
                                    []
                                ];
                            }
                            if (!shouldUseGraphQl) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                get_bundle_deals({
                                    latitude: latitude,
                                    longitude: longitude
                                })
                            ];
                        case 1:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                get_price_cache({
                                    latitude: latitude,
                                    longitude: longitude
                                })
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            bundleDeals = _tmp;
                            if (bundleDeals.length > 0) {
                                setFetchSucceeded(true);
                                setDeals(bundleDeals);
                            } else {
                                setFetchSucceeded(false);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPackageDeals() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPackageDeals();
    }, [
        latitude,
        longitude,
        shouldUseGraphQl
    ]);
    return {
        deals: deals,
        didFetchSucceed: didFetchSucceed
    };
};
/* harmony default export */ var hooks_useFetchPackages = (useFetchPackages);

// EXTERNAL MODULE: ./src/hooks/useGeoPosition.ts
var useGeoPosition = __webpack_require__(29657);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateX(-200px)\n  }\n  100% {\n    transform: translateX(",
        "px)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #eee;\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  line-height: 1;\n  width: ",
        ";\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background-image: linear-gradient(\n    to right,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  background-image: -webkit-linear-gradient(\n    left,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  animation: ",
        " 1.2s ease-in-out infinite;\n  height: 100%;\n  width: 200px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var animation = function(param) {
    var animationWidth = param.animationWidth;
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), animationWidth);
};
var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46a10e27-0"
})(_templateObject1(), function(props) {
    return props.width ? props.width : "100%";
}, function(param) {
    var height = param.height;
    return height && "height: ".concat(height, ";");
});
var Glare = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-46a10e27-1"
})(_templateObject2(), animation);
function Skeleton(param) {
    var height = param.height, width = param.width, _animationWidth = param.animationWidth, animationWidth = _animationWidth === void 0 ? 100 : _animationWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        height: height,
        width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glare, {
            animationWidth: animationWidth + 200,
            children: "‌"
        })
    });
}
/* harmony default export */ var components_Skeleton = (Skeleton);

;// CONCATENATED MODULE: ./src/components/DealCarouselLoader/index.tsx

function DealCarouselLoader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 379px;\n"
    ]);
    DealCarouselLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ItemFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6b24c7b0-0"
})(DealCarouselLoader_templateObject());
function ItemCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        p: 3,
        boxShadowSize: "sm",
        borderWidth: 0,
        width: [
            1,
            null,
            null,
            1 / 3
        ],
        mx: [
            null,
            null,
            null,
            2
        ],
        my: [
            2,
            null
        ],
        borderRadius: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                        height: "200px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function DealCarouselLoader() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 1200,
        "data-testid": "deal-carousel-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            px: 3,
            py: 1,
            width: 1,
            borderWidth: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemFlex, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {})
                ]
            })
        })
    });
}
/* harmony default export */ var components_DealCarouselLoader = (DealCarouselLoader);

// EXTERNAL MODULE: ./src/components/LayoutComponentWrapper/index.tsx
var LayoutComponentWrapper = __webpack_require__(47418);
;// CONCATENATED MODULE: ./src/components/PackagesCarousel/index.tsx







function PackagesCarousel(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "Don't miss these package deals" : _heading, _headingMobile = param.headingMobile, headingMobile = _headingMobile === void 0 ? "Don't miss these deals" : _headingMobile;
    var ref = (0,useGeoPosition/* default */.Z)(), longitude = ref.longitude, latitude = ref.latitude;
    var ref1 = hooks_useFetchPackages({
        latitude: latitude,
        longitude: longitude
    }), deals = ref1.deals, didFetchSucceed = ref1.didFetchSucceed;
    if (!didFetchSucceed) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutComponentWrapper/* default */.Z, {
        children: deals.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule/* default */.Z, {
            content: {
                heading: heading,
                headingMobile: headingMobile,
                dataArray: deals
            },
            handleNavOnClick: function(href) {
                return window.open(href);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DealCarouselLoader, {})
    });
}
/* harmony default export */ var components_PackagesCarousel = (PackagesCarousel);


/***/ }),

/***/ 89162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ScrollableDealModule; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@pcln/content-tile/dist/esm/index.js + 3 modules
var esm = __webpack_require__(60034);
// EXTERNAL MODULE: ./node_modules/@pcln/price-box/dist/esm/index.js + 11 modules
var dist_esm = __webpack_require__(46364);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowUp.js
var ArrowUp = __webpack_require__(25192);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowDown.js
var ArrowDown = __webpack_require__(79016);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(88410);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/ArrowButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  width: 40px;\n\n  &&& {\n    border-radius: 50%;\n    padding: 8px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var RoundButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-1ab2f881-0"
})(_templateObject());
var iconLookup = {
    up: ArrowUp/* default */.Z,
    down: ArrowDown/* default */.Z,
    left: ArrowLeft/* default */.Z,
    right: ArrowRight/* default */.Z
};
function ArrowButton(_param) {
    var direction = _param.direction, disabled = _param.disabled, onClick = _param.onClick, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "direction",
        "disabled",
        "onClick",
        "label"
    ]);
    var IconDirection = iconLookup[direction];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        disabled: disabled,
        onClick: onClick,
        "data-testid": "arrow".concat(direction),
        "aria-label": label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDirection, {})
    }));
}
/* harmony default export */ var ScrollableDealModule_ArrowButton = (ArrowButton);

;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/index.tsx
/* eslint-disable react/destructuring-assignment */ 




function ScrollableDealModule_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    ScrollableDealModule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration-line: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var RemainingWidthFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-f4653163-0"
})(ScrollableDealModule_templateObject());
var NoWrapText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-f4653163-1"
})(_templateObject1(), theme/* mediaQueries.1 */.w5[1]);
var NoDecorationLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-f4653163-2"
})(_templateObject2());
var TextSpan = Text/* default.span */.ZP.span;
var getImageTile = function(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ImageTile */.a5, {
                height: data.imageHeight,
                image: data.image,
                imageWebP: data.imageWebP,
                navArray: data.navArray,
                handleNavOnClick: isUsingNavArrows && handleNavOnClick,
                isOpaque: isOpaque,
                borderRadius: "xl",
                rounded: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                color: "text",
                p: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 0,
                                children: data.productName
                            }),
                            !!data.strikePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* StrikePrice */.Ch, {
                                price: data.strikePrice,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                        fontSize: 3,
                                        fontWeight: "bold",
                                        children: data.cityName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 0,
                                        mt: 1,
                                        children: data.description
                                    })
                                ]
                            }),
                            !!data.priceAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                mt: "1px",
                                ml: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "baseline",
                                    children: [
                                        isUsingPricePrefix && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                                            mx: 2,
                                            color: "pricePrimary",
                                            fontSize: 4,
                                            fontWeight: "bold",
                                            children: data.pricePrefix
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* PriceBox */.bz, {
                                            priceSize: "small",
                                            price: data.priceAmount,
                                            priceColor: "pricePrimary",
                                            priceType: isUsingPriceType && "per person",
                                            alignItems: "right",
                                            toFixDecimal: 0
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// TODO: improve the list of params using "deeper" React pattern
var parseDealTiles = function(dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, position, numDealsToDisplay, isTrips, handleNavOnClick) {
    var items = dataArray.slice(position, position + numDealsToDisplay);
    return items.map(function(data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: function() {
                analytics/* default.fireEvent */.Z.fireEvent({
                    action: data.gaAction,
                    category: data.gaCategory,
                    label: data.cityName
                });
            },
            mx: [
                0,
                2
            ],
            borderRadius: "xl",
            boxShadowSize: "md",
            borderWidth: 0,
            width: [
                1,
                1 / numDealsToDisplay
            ],
            "data-testid": "deal-tile-".concat(data.cityName),
            children: isTrips ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                onClick: data.onTileClick,
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDecorationLink, {
                href: data.navArray[0].href,
                target: "_blank",
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            })
        }, "deal-tile-".concat(data.cityName));
    });
};
var ScrollableDealModule = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ScrollableDealModule, _Component);
    var _super = (0,_create_super/* default */.Z)(ScrollableDealModule);
    function ScrollableDealModule(props) {
        (0,_class_call_check/* default */.Z)(this, ScrollableDealModule);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            position: 0,
            numDealsToDisplay: 0
        };
        _this.handleLeftArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), false);
        _this.handleRightArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), true);
        _this.handleResize = _this.handleResize.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ScrollableDealModule.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            numDealsToDisplay: // eslint-disable-next-line no-nested-ternary
            window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1
        });
        // eslint-disable-next-line @typescript-eslint/unbound-method
        window.addEventListener("resize", this.handleResize);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        window.removeEventListener("resize", this.handleResize);
    };
    _proto.handleResize = function handleResize() {
        var screenSize = window.innerWidth;
        if (screenSize >= 1024 && this.state.numDealsToDisplay !== 3) {
            this.setState({
                numDealsToDisplay: 3
            });
        } else if (screenSize >= 640 && screenSize < 1024 && this.state.numDealsToDisplay !== 2) {
            this.setState({
                numDealsToDisplay: 2
            });
        } else if (screenSize < 640 && this.state.numDealsToDisplay !== 1) {
            this.setState({
                numDealsToDisplay: 1
            });
        }
    };
    _proto.updatePosition = function updatePosition(shouldAdd) {
        if (shouldAdd) {
            var maxIndex = this.props.content.dataArray.length - this.state.numDealsToDisplay;
            var nextPosition = this.state.position + this.state.numDealsToDisplay;
            var position = Math.min(nextPosition, maxIndex);
            this.setState({
                position: position
            });
        } else {
            var nextPosition1 = this.state.position - this.state.numDealsToDisplay;
            var position1 = Math.max(nextPosition1, 0);
            this.setState({
                position: position1
            });
        }
    };
    _proto.render = function render() {
        var _props = this.props, content = _props.content, handleNavOnClick = _props.handleNavOnClick, _isUsingNavArrows = _props.isUsingNavArrows, isUsingNavArrows = _isUsingNavArrows === void 0 ? true : _isUsingNavArrows, _isUsingPriceType = _props.isUsingPriceType, isUsingPriceType = _isUsingPriceType === void 0 ? true : _isUsingPriceType, _isUsingPricePrefix = _props.isUsingPricePrefix, isUsingPricePrefix = _isUsingPricePrefix === void 0 ? false : _isUsingPricePrefix, _isOpaque = _props.isOpaque, isOpaque = _isOpaque === void 0 ? true : _isOpaque, _isTrips = _props.isTrips, isTrips = _isTrips === void 0 ? false : _isTrips;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    ml: 2,
                    pb: 24,
                    fontSize: 4,
                    fontWeight: "bold",
                    m: 0,
                    color: "text.heading",
                    textStyle: "heading2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: content.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            sm: true,
                            md: true,
                            lg: true,
                            xl: true,
                            xxl: true,
                            children: content.headingMobile
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "left",
                                mr: 3,
                                disabled: this.state.position === 0,
                                onClick: this.handleLeftArrowClick,
                                label: "Scroll backward through the deals"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingWidthFlex, {
                            flexDirection: [
                                "column",
                                "row"
                            ],
                            children: parseDealTiles(content.dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, this.state.position, this.state.numDealsToDisplay, isTrips, handleNavOnClick)
                        }),
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "right",
                                disabled: this.state.position >= content.dataArray.length - this.state.numDealsToDisplay,
                                onClick: this.handleRightArrowClick,
                                label: "Scroll forward through the deals"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return ScrollableDealModule;
}(react.Component);
/* harmony default export */ var components_ScrollableDealModule = (ScrollableDealModule);


/***/ })

}]);